import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: start;
  block-size: 100%;
  inline-size: 100%;
  /* padding: 0 0 0 1rem; */
  padding: 2rem 0 2rem 1rem;
  
  overflow: hidden;

  .page-title {
    margin: 0 0 1rem 0;
    width: 100%;
  }

  @media (min-width: 768px) {
    gap: 1.5rem;
    
    .page-title {
      margin-bottom: 1.5rem;
    }
  }

  @media (min-width: 1200px) {
    gap: 2.2222222222rem;
    
    .page-title {
      margin-bottom: 2rem;
    }
  }
`;

export const UpperCardsRow = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 1.5rem;
  }

  @media (min-width: 1200px) {
    gap: 2rem;
  }
`;

export const LowerCardsRow = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  
  flex-direction: column;

  @media (min-width: 480px) {
    gap: 1.5rem;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem;
    
    > * {
      flex: 1;
      min-width: 250px;
      max-width: 100%;
      box-sizing: border-box;
    }
  }

  @media (min-width: 1200px) {
    flex-wrap: nowrap;
    gap: 2rem;
    
    > * {
      flex: 1;
      min-width: 0;
      max-width: calc(33.333% - 1.333rem);
      box-sizing: border-box;
    }
  }

  @media (min-width: 1600px) {
    gap: 2.5rem;
    
    > * {
      max-width: calc(33.333% - 1.666rem);
    }
  }
`;